/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.stockSkuPlatform.info.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/platform/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
